











import { Component, Prop, Vue } from 'vue-property-decorator'

type ButtonColors = 'danger' | 'primary' | 'success'

@Component
export default class CopyButton extends Vue {
  @Prop({ type: String, required: true })
  readonly message!: string

  @Prop({ type: Boolean })
  readonly isDisabled!: boolean

  copyColor: ButtonColors = 'primary'
  isLockedCopy = false

  onCopy (success: boolean) {
    if (!this.isLockedCopy) {
      this.isLockedCopy = true

      this.copyColor = success
        ? 'success'
        : 'danger'

      setTimeout(() => {
        this.copyColor = 'primary'
        this.isLockedCopy = false
      }, 2000)

      if (!success) {
        this.$vs.notify({
          title: 'Não foi possível copiar.',
          text: 'Você pode selecionar o texto no campo.',
          color: 'danger',
          fullWidth: true
        })
      }
    }
  }
}
